<template>
  <div class="task-track" v-loading="loading">
    <div class="anCore-pageToolBar">
      <a href="javascript:;" style="margin-right:25px;" @click.prevent="goHistory">历史记录查询</a>
      <span v-if="current && current.xmbh" class="text-muted small">{{ current.ProjectName }}</span>
      <div style="position:absolute;top:10px;right:55px;">
        <a
          class="btn btn-default btn-sm"
          :class="{ active: showOverview }"
          style="padding-right:30px;"
          title="点此显示任务概况"
          href="javascript:;"
          @click.prevent="toggleOverview"
        >
          <i class="fa fa-bar-chart" /> 概况
        </a>
      </div>
    </div>

    <div class="row" style="margin:0;height:calc(100% - 40px);">
      <div class="col-md-5 task-track__left">
        <IvanGroupProjectList
          :groups="groups"
          :current-xmbh="current && current.xmbh"
          :show-search="true"
          :track-mode="true"
          :bold-title="true"
          empty-text="暂无进行中任务"
          @select="selectProject"
        />
      </div>
      <div class="col-md-7 task-track__right">
        <div v-show="showOverview" class="task-track__overview">
          <div class="task-track__hint text-muted">
            请在<strong>左侧点击项目名称</strong>，右侧会显示流程节点与本项目表单；点表单卡片可直接打开原表。
          </div>
          <div class="ivan-stat-card">
            <div class="ivan-stat-card__inner">
              <div class="pull-left text-center" style="width:19%;font-size:18px;padding:5px 0;">
                <i class="fa fa-clock-o" style="margin-right:10px;color:#1AAEDA;" />
                <span style="color:#44B2d6;">进行中</span>
              </div>
              <div class="pull-left" style="width:20%;border-left:5px solid #e9f0f5;">
                <div style="font-size:18px;font-weight:bold;">{{ projectTaskCount }}</div>
                <div class="text-muted">监测任务</div>
              </div>
              <div class="pull-left" style="width:20%;">
                <div style="font-size:18px;font-weight:bold;">{{ pickTaskCount }}</div>
                <div class="text-muted">采样任务</div>
              </div>
              <div class="pull-left" style="width:20%;">
                <div style="font-size:18px;font-weight:bold;">{{ sampleCount }}</div>
                <div class="text-muted">样品</div>
              </div>
              <div class="pull-left" style="width:20%;">
                <div style="font-size:18px;font-weight:bold;">{{ reportCount }}</div>
                <div class="text-muted">报告</div>
              </div>
            </div>
          </div>

          <div class="ivan-chart-card">
            <div class="ivan-chart-card__title">本年度任务量统计</div>
            <div ref="projectChart" style="height:250px;" />
          </div>
          <div class="ivan-chart-card">
            <div class="ivan-chart-card__title">本年度报告量统计</div>
            <div ref="reportChart" style="height:250px;" />
          </div>
        </div>

        <div v-if="!showOverview && current" class="task-track__detail">
          <TaskStepTimeline
            :project="current"
            :picks="current.pickRows || []"
            @open-form="onTimelineForm"
          />
          <ProjectFormWall
            ref="formWall"
            :xmbh="current.xmbh"
            @open-form="openProjectForm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import IvanGroupProjectList from '@/components/ivan/IvanGroupProjectList.vue'
import TaskStepTimeline from '@/components/ivan/TaskStepTimeline.vue'
import ProjectFormWall from '@/components/ivan/ProjectFormWall.vue'
import { fetchDoingPickBundle, yearMonthStats } from '@/utils/pickAdminAdapter'

const MONTHS = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']

export default {
  name: 'TaskTrack',
  components: { IvanGroupProjectList, TaskStepTimeline, ProjectFormWall },
  data() {
    return {
      loading: false,
      groups: [],
      projectViews: [],
      current: null,
      showOverview: true,
      projectTaskCount: 0,
      pickTaskCount: 0,
      sampleCount: 0,
      reportCount: 0,
      monthCreated: [],
      monthDone: [],
      projectChart: null,
      reportChart: null
    }
  },
  watch: {
    '$route.query.xmbh'(v) {
      if (v) this.selectByXmbh(String(v))
    }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    if (this.projectChart) this.projectChart.dispose()
    if (this.reportChart) this.reportChart.dispose()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const bundle = await fetchDoingPickBundle()
        this.groups = bundle.groups
        this.projectViews = bundle.projectViews || []
        this.projectTaskCount = bundle.projectTaskCount
        this.pickTaskCount = bundle.pickTaskCount
        this.sampleCount = bundle.pickTaskCount
        this.reportCount = this.projectViews.filter(v => {
          const zt = String((v.rawXm && v.rawXm.xmzt) || '').toLowerCase()
          return zt === 'reporting' || zt === 'done'
        }).length
        const ym = yearMonthStats(this.projectViews)
        this.monthCreated = ym.created
        this.monthDone = ym.done

        const qx = this.$route.query.xmbh
        if (qx) {
          this.selectByXmbh(String(qx))
        } else if (!this.current && this.projectViews.length) {
          this.selectProject(this.projectViews[0])
        }
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error('加载任务监控失败')
      } finally {
        this.loading = false
      }
    },
    renderCharts() {
      if (!this.$refs.projectChart || !this.$refs.reportChart) return
      if (!this.projectChart) this.projectChart = echarts.init(this.$refs.projectChart)
      if (!this.reportChart) this.reportChart = echarts.init(this.$refs.reportChart)

      this.projectChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['新建', '完成'] },
        grid: { left: 40, right: 20, top: 40, bottom: 30 },
        xAxis: { type: 'category', data: MONTHS },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          { name: '新建', type: 'bar', data: this.monthCreated, itemStyle: { color: '#7cb5ec' } },
          { name: '完成', type: 'bar', data: this.monthDone, itemStyle: { color: '#90ed7d' } }
        ]
      })

      this.reportChart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 20, top: 30, bottom: 30 },
        xAxis: { type: 'category', data: MONTHS },
        yAxis: { type: 'value', minInterval: 1 },
        series: [{
          name: '报告',
          type: 'line',
          data: this.monthDone,
          itemStyle: { color: '#1AAEDA' },
          areaStyle: { color: 'rgba(26,174,218,0.15)' }
        }]
      })
    },
    resizeCharts() {
      if (this.projectChart) this.projectChart.resize()
      if (this.reportChart) this.reportChart.resize()
    },
    toggleOverview() {
      this.showOverview = true
      this.current = null
      if (this.$route.query.xmbh) {
        const q = { ...this.$route.query }
        delete q.xmbh
        this.$router.replace({ path: '/task-track', query: q }).catch(() => {})
      }
      this.$nextTick(() => this.renderCharts())
    },
    selectProject(p) {
      this.current = p
      this.showOverview = false
      if (p && p.xmbh && this.$route.query.xmbh !== p.xmbh) {
        this.$router.replace({ path: '/task-track', query: { ...this.$route.query, xmbh: p.xmbh } }).catch(() => {})
      }
    },
    selectByXmbh(xmbh) {
      const x = String(xmbh || '').trim()
      if (!x) return
      const hit = (this.projectViews || []).find(v => String(v.xmbh) === x)
      if (hit) {
        this.selectProject(hit)
        return
      }
      // 列表里暂时没有（如刚跳转）：仍展示表单墙
      this.current = {
        xmbh: x,
        ProjectName: x,
        pickRows: []
      }
      this.showOverview = false
    },
    onTimelineForm(step) {
      if (!this.current) return
      const name = (step && (step.nodeName || step.NodeName)) || ''
      if (name === '采样任务管理') {
        this.$router.push({ path: '/pick/batch-contract', query: { xmbh: this.current.xmbh } }).catch(() => {})
        return
      }
      let phaseKey = 'sampling'
      if (/派遣|委托|下单/.test(name)) phaseKey = 'dispatch'
      else if (/交接|接样/.test(name)) phaseKey = 'handover'
      else if (/理化|分析|报告/.test(name)) phaseKey = 'lab'
      else if (/采样|现场/.test(name)) phaseKey = 'sampling'
      this.$nextTick(() => {
        if (this.$refs.formWall) this.$refs.formWall.expandPhase(phaseKey)
      })
    },
    openProjectForm(form) {
      if (!form || !form.actionUrl) {
        this.$message.warning('该表单暂未配置打开方式')
        return
      }
      const r = String(form.actionUrl)
      const qi = r.indexOf('?')
      if (qi >= 0) {
        const path = r.slice(0, qi)
        const query = {}
        r.slice(qi + 1).split('&').forEach(pair => {
          if (!pair) return
          const eq = pair.indexOf('=')
          const k = eq >= 0 ? pair.slice(0, eq) : pair
          const v = eq >= 0 ? decodeURIComponent(pair.slice(eq + 1)) : ''
          query[k] = v
        })
        this.$router.push({ path, query }).catch(() => {})
      } else {
        this.$router.push(r).catch(() => {})
      }
    },
    goHistory() {
      this.$router.push('/stub/pick-history')
    }
  }
}
</script>

<style scoped>
.task-track {
  height: 100%;
  position: relative;
  background: #fff;
}
.anCore-pageToolBar {
  position: relative;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  border-bottom: 1px solid #e8e8e8;
}
.task-track__left {
  height: 100%;
  overflow: auto;
  padding: 0;
  background: #fff;
}
.task-track__right {
  height: 100%;
  overflow: hidden;
  background-color: #e9f0f5;
  padding: 0;
  position: relative;
}
.task-track__overview {
  height: 100%;
  overflow: auto;
  padding: 5px;
}
.task-track__detail {
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 16px;
  position: relative;
}
.task-track__detail >>> .pfw {
  position: relative;
  z-index: 1;
}
.task-track__hint {
  background: #f0f9ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 12px;
  line-height: 1.6;
  font-size: 13px;
}
.ivan-stat-card {
  height: 80px;
  margin: 10px;
  background: white;
  border-radius: 0.25em;
  box-shadow: rgb(215, 228, 237) 0 3px 0;
  text-align: center;
}
.ivan-stat-card__inner {
  height: 80px;
  width: 100%;
  padding-top: 20px;
}
.ivan-chart-card {
  margin: 10px;
  background: white;
  border-radius: 0.25em;
  padding: 1em;
  box-shadow: rgb(215, 228, 237) 0 3px 0;
}
.ivan-chart-card__title {
  border-left: 3px #1AAEDA solid;
  font-size: 16px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 8px;
}
</style>
